import { render, staticRenderFns } from "./BreedDetail.vue?vue&type=template&id=226f4878&scoped=true&"
import script from "./BreedDetail.vue?vue&type=script&lang=js&"
export * from "./BreedDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f4878",
  null
  
)

export default component.exports